import $ from 'jquery'
import AOS from 'aos'

export class Aos {

  constructor () {
    AOS.init(
      {
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        mirror: false, // whether elements should animate out while scrolling past them
      }
    );

    $(window).on('load', this.refresh.bind(this));
  }

  refresh() {
    AOS.refresh();
  }
}
